import { useContext, useEffect } from 'react';
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "../../../../hooks/useLoader";
import { QueryStatus } from "../../../../types";
import { Alert, Grid } from "@mui/material";
import { OperacionAFOCL } from "./types/types";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { SistemaTipo } from "../../../../types/enum/enum";
import SeccionAFOCLDatosOperacion from './components/SeccionAFOCLDatosOperacion';
import { useOperacionAFOCL } from './hooks/useOperacionAFOCL';
import { SeccionAFOCLTablaValores } from './components/SeccionAFOCLTablaValores';
import { OperacionAFOCLFields } from './types/fields';


interface SistemaAFOCLContentProps {
  operacion: OperacionAFOCL
}

const SistemaAFOCLContent = ({ operacion }: SistemaAFOCLContentProps) => {
  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionAFOCLDatosOperacion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionAFOCLTablaValores operacion={operacion} codSistemaPrincipal={operacion[OperacionAFOCLFields.CodPais]}/>
        </Grid>

        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.AFOCL}
            idOperacion={operacion.id}
          />
        </Grid>
      </Grid>
    </>
  )
}

function SistemaAFOCL() {
  const { idOperacion } = useContext<ContextOperacionType>(ContextOperacion);
  const { status, operacion } = useOperacionAFOCL(idOperacion);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status]);

  if (!operacion) {
    return null;
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  return (
    <SistemaAFOCLContent
      operacion={operacion}
    />
  )
}

export default SistemaAFOCL;